import alert from '../../components/alerts.js'

const stripe = Stripe(window.stripeKey);

export default () => {
  const elements = stripe.elements()

  const cardCvc = elements.create('cardCvc', {
    classes: {
      empty: 'stripe-element-empty',
      focus: 'stripe-element-focus',
      invalid: 'stripe-element-invalid',
    },
  })
  cardCvc.mount('#cardCvc')

  const form = document.getElementById('confirm-card-payment-form')
  const submitButton = document.getElementById('submit-button')
  const clientSecret = document.getElementById('client-secret').value
  const paymentMethodId = document.getElementById('payment-method-id').value

  form.addEventListener('submit', function(event) {
    event.preventDefault()
    submitButton.disabled = true
    submitButton.innerHTML = '<i class="fas fa-spin fa-circle-notch"></i>'

    stripe
      .confirmCardPayment(clientSecret, {
        payment_method: paymentMethodId,
        payment_method_options: {
          card: {
            cvc: cardCvc,
          },
        },
      })
      .then(function(result) {
        if (result.error) {
          new alert().response('error', result.error.message)
          submitButton.disabled = false
          submitButton.innerHTML = '<span>Pagar</span>'
        } else if (
          result.paymentIntent &&
          result.paymentIntent.status === 'succeeded'
        ) {
          form.submit();
        }
      })
  })
}
